module.exports = __webpack_public_path__ + "media/images/countryrect/cn-e058fb43239db6403d55cf6ff393d03e.svg";